module.exports = __webpack_public_path__ + "img/mapnew_small1.3ae9f337.png";